module.exports = __webpack_public_path__ + "img/honor-5.e74597d5.png";